/**
 * Chunk L1 — Close the dashboard upload loop.
 * Post-confirm “what happens next?” + teach-once “Why upload?”
 * (Menu Builder + stock take), especially Free / single-site.
 */

/** Same story as app `APP_INVOICE_CAPTURE_COPY` why-upload. */
export const UPLOAD_LOOP_CLOSE_COPY = {
  postConfirmTitle: 'It’s in Invoices',
  postConfirmBody:
    'Match when you’re ready — open it from your library to link it to a purchase order.',

  whyUploadTitle: 'Why upload invoices?',
  whyUploadBody:
    'Uploading invoices keeps your prices and spend accurate in OMS — which really helps Menu Builder costing and stock take.',
  whyUploadGotIt: 'Got it',
}

/** Post-confirm notification payload for SuccessNotification. */
export function getPostConfirmNextStepNotification() {
  return {
    message: UPLOAD_LOOP_CLOSE_COPY.postConfirmTitle,
    description: UPLOAD_LOOP_CLOSE_COPY.postConfirmBody,
  }
}

/** Why-upload teach — once per venue until dismissed. */
export function getWhyUploadTeachStorageKey(venueId) {
  return `invoices_why_upload_teach_dismissed_${String(venueId || '').trim()}`
}

export function isWhyUploadTeachDismissed(venueId) {
  if (!venueId || typeof localStorage === 'undefined') return false
  return localStorage.getItem(getWhyUploadTeachStorageKey(venueId)) === '1'
}

export function dismissWhyUploadTeach(venueId) {
  if (!venueId || typeof localStorage === 'undefined') return
  localStorage.setItem(getWhyUploadTeachStorageKey(venueId), '1')
}

/**
 * Show teach-once for Free plan and/or single-site venue owners.
 * Skip OMS admins (they’re not the Menu Builder / stock-take persona).
 */
export function shouldShowWhyUploadTeach(
  venueId,
  { currentPlan, venueCount = 0, isAdmin = false } = {},
) {
  if (!venueId || isAdmin) return false
  if (isWhyUploadTeachDismissed(venueId)) return false

  const free = String(currentPlan || '').trim() === 'Free'
  const count = Number(venueCount)
  const singleSite = Number.isFinite(count) && count > 0 && count <= 1
  return free || singleSite
}
